import { Button as GroveButton, theme as groveTheme } from '@acorns/grove'
import { Button, CheckboxInput } from '@acorns/web-components'
import { transparentize } from 'polished'
import styled, { css, keyframes } from 'styled-components'

import FilledClock from 'assets/icons/filled-clock.svg'
import CheckMark from 'assets/icons/thicc-check.svg'
import WelcomeBackBg from 'assets/images/growth-aspiration-illustration.svg'
import { Content } from 'pages/portfolio/ChangePortfolioTheme/preview-portfolio/styled-components'
import theme from 'theme'

export const Container = styled.div<{ isPortfolioPage?: boolean }>`
  background: ${theme.colors.white};
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.03);
  border-radius: 10px;
  max-width: 800px;
  margin: 0 auto;
  height: auto;
  padding-top: 80px;
  ${(props) =>
    props.isPortfolioPage &&
    css`
      margin-top: 74px;
      padding-top: 0;
    `}
`

export const ScrollContainer = styled.div<{ height: number }>`
  @media (min-width: ${theme.breakpoints.sm + 1}px) {
    overflow-y: auto;
    height: calc(100vh - (${(props) => props.height}px + 335px));
    min-height: 300px;
  }
`

export const TextContainer = styled.div<{ hideBottomBorder?: boolean }>`
  padding: 50px;
  text-align: center;
  border-bottom: ${(props) =>
    !props.hideBottomBorder && `1px solid ${theme.colors.ivoryLight}`};
  width: 100%;
  @media screen and (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
    padding: 30px 20px;
    padding-top: calc(30px + env(safe-area-inset-top, 0));
    min-height: 620px;
  }
`

export const ButtonContainer = styled.div`
  padding: 30px;
  @media screen and (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 20px calc(20px + env(safe-area-inset-bottom, 0));
    background: ${groveTheme.colors.primaryWhite};
    z-index: 100;
  }
`

export const Body = styled.p`
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: ${theme.colors.charcoal};
  max-width: 315px;
  margin: 0 auto;
`

export const Title = styled.h2`
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
  color: ${theme.colors.charcoal};
  margin: 20px auto 10px;
`

export const StyledButton = styled(Button)<{ margin: string }>`
  width: 220px;
  margin: ${(props) => props.margin};

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    width: 100%;
  }
`

export const Loader = styled.div`
  align-items: center;
  display: flex;
  height: 100vh;
`
export const CenteredSpinner = styled.div`
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const AgreementContainer = styled.div<{ isRedesignVariant?: boolean }>`
  max-width: 335px;
  margin: 0 auto;
  padding-bottom: 20px;
  text-align: left;
  display: flex;
  align-items: ${(props) =>
    props.isRedesignVariant ? 'flex-start' : 'center'};
  @media screen and (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
    max-width: none;
    margin: ${(props) =>
      props.isRedesignVariant ? '0px auto' : '20px auto 0'};
  }
`

export const AgreementCheckbox = styled.div<{
  isChecked: boolean
  isRedesignVariant?: boolean
}>`
  width: 22px;
  height: 22px;
  margin-right: 10px;
  background-color: ${(props) => props.isChecked && theme.colors.green};
  background-image: ${(props) => props.isChecked && `url(${CheckMark})`};
  border: ${(props) =>
    !props.isChecked && `1px solid ${theme.colors.stoneLight}`};
  border-radius: ${(props) => (props.isRedesignVariant ? '8px' : '50%')};
  cursor: pointer;
  background-size: 12px 12px;
  background-position: center;
  background-repeat: no-repeat;
`

export const AgreementText = styled.p<{ isRedesignVariant?: boolean }>`
  flex: 1;
  font-size: 12px;
  line-height: 16px;
  color: ${(props) =>
    props.isRedesignVariant
      ? groveTheme.colors.primaryWhite
      : theme.colors.slate};
  margin: 0;

  > a {
    text-decoration: underline;
    color: ${(props) =>
      props.isRedesignVariant
        ? groveTheme.colors.primaryWhite
        : theme.colors.slate};
  }
`

export const DisclaimerContainer = styled.div`
  padding: 20px;
  border-radius: 6px;
  background-color: rgba(245, 245, 245, 0.5);
  text-align: center;
  max-width: 335px;
  margin: -20px auto 50px;
  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    margin: 20px;
    max-width: none;
  }
`

export const Disclaimer = styled.p`
  font-size: 12px;
  line-height: 16px;
  margin: 0;
`

export const MessageContainer = styled.div`
  background: ${theme.colors.white};
  box-shadow: ${theme.shadows.lgLight};
  border-radius: 10px;
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  min-height: 400px;

  @media screen and (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
    min-height: 100dvh;
    justify-content: flex-start;
  }
`

export const IconCircle = styled.div`
  border-radius: 100%;
  box-shadow: ${theme.shadows.lgMedium};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  margin: 0 auto 30px;
  position: relative;
`

export const ClockIcon = styled.div`
  height: 20px;
  width: 20px;
  position: absolute;
  background: url(${FilledClock}) no-repeat center center;
  top: 4px;
  right: 4px;
`

export const UploadDocuments = styled.p`
  text-align: center;
  font-size: 12px;
  line-height: 16px;
  color: ${theme.colors.stone};
  margin: 50px auto -20px;

  > a {
    text-decoration: underline;
    color: ${theme.colors.stone};
  }

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    margin: 50px auto 0;
  }
`

export const ReopenMessage = styled(Body)`
  margin: 0 auto;
  max-width: 340px;
`

export const ReopenSuccessIcon = styled.img`
  margin: 30px auto 40px;
  max-width: 250px;
  max-height: 150px;

  @media (max-width: ${theme.breakpoints.sm}px) {
    margin-bottom: 30px;
  }
`

export const StyledContent = styled(Content)`
  @media (max-width: ${theme.breakpoints.sm}px) {
    padding-top: 10px;
  }
`

export const Headline = styled.div`
  padding: 0 30px;
`

export const HeadlineContent = styled.div`
  @media (min-width: ${theme.breakpoints.sm + 1}px) {
    max-width: 340px;
    margin: 0 auto;
  }
`

export const HeadlineText = styled.div`
  font-weight: 600;
  font-size: 22px;
  color: ${theme.colors.slate};
`

export const StyledLogoFull = styled.img`
  position: fixed;
  left: 30px;
  z-index: 1;
  height: 36px;
  top: 30px;
  width: auto;
  object-fit: contain;

  @media (min-width: ${theme.breakpoints.sm + 1}px) {
    display: none;
  }
`

export const StyledLogoutButton = styled(GroveButton)`
  position: fixed;
  right: 30px;
  z-index: 100;
  width: fit-content;

  @media (min-width: ${groveTheme.dimensions.breakpointsSmall + 1}px) {
    top: 12px;
    background-color: transparent;
  }

  @media (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
    top: 30px;
    color: ${groveTheme.colors.primaryWhite};
    background-color: ${groveTheme.colors.naturalLightOak};
    height: 36px;
  }
`

export const WelcomeBackMessageContainer = styled.div`
  background: ${groveTheme.colors.naturalMidnightForest};
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  min-height: 600px;
  background-image: url(${WelcomeBackBg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center calc(100% - 84px);
  position: relative;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    border-radius: 10px;
    background: linear-gradient(
      to bottom,
      ${groveTheme.colors.naturalMidnightForest}00 0,
      ${groveTheme.colors.naturalMidnightForest}4D 40%,
      ${groveTheme.colors.naturalMidnightForest}B3 60%,
      ${groveTheme.colors.naturalMidnightForest} calc(100% - 84px)
    );
  }
  @media (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
    height: 100dvh;
    padding-bottom: env(safe-area-inset-bottom, 0);
    background-position: calc(100% + 60px) calc(100% - 137px);
    border-radius: 0;
    &::before {
      border-radius: 0;
      background: linear-gradient(
        to bottom,
        ${groveTheme.colors.naturalMidnightForest}00 0,
        ${groveTheme.colors.naturalMidnightForest}4D 50%,
        ${groveTheme.colors.naturalMidnightForest}B3 70%,
        ${groveTheme.colors.naturalMidnightForest} calc(100% - 137px)
      );
    }
  }
  @media (min-width: ${groveTheme.dimensions.breakpointsSmall + 1}px) {
    border-radius: 10px;
    margin-top: 70px;
  }
  > * {
    position: relative;
    z-index: 2;
  }
`

export const WelcomeBackContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 335px;
  margin-bottom: 50px;
  @media (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
    margin-bottom: 20px;
  }
`

export const WelcomeBackTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`

export const WelcomeBackHeadlineText = styled.div`
  font-weight: ${groveTheme.fontWeight.demiBold};
  font-size: ${groveTheme.fontSize._30};
  color: ${groveTheme.colors.primaryWhite};
`

export const WelcomeBackBodyText = styled.div`
  font-size: ${groveTheme.fontSize._14};
  line-height: ${groveTheme.lineHeight._22};
  color: ${groveTheme.colors.primaryWhite};
  text-align: center;
`

export const WelcomeBackButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const DocumentButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`

export const StyledDocumentButton = styled(GroveButton)`
  width: 100%;
  background-color: ${groveTheme.colors.naturalDarkForest};
  padding: 0;
  font-size: ${groveTheme.fontSize._14};
  &:hover {
    background-color: ${groveTheme.colors.naturalDarkForest};
  }
`

export const StyledReopenButton = styled(GroveButton)`
  width: 100%;
  font-size: ${groveTheme.fontSize._14};
`

export const SurveyPageBackground = styled.div`
  background: ${groveTheme.colors.primaryWhite};
  overflow: hidden;
  overscroll-behavior: none;
  @media screen and (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
    position: fixed;
    inset: 0;
  }
`

export const SurveyCardContainer = styled.div`
  background: ${groveTheme.colors.primaryWhite};
  box-shadow: ${groveTheme.shadows.largeLight};
  border-radius: 10px;
  max-width: 800px;
  height: 680px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  --cta-offset: 136px;

  @media screen and (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
    box-shadow: none;
    border-radius: 0;
    height: 100dvh;
  }
`

export const SurveyHeader = styled.div`
  width: 340px;
  margin: 0 auto;

  @media screen and (min-width: ${groveTheme.dimensions.breakpointsSmall +
    1}px) {
    padding-top: 50px;
  }
`

export const SurveyScroll = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  position: relative;
  overscroll-behavior-y: contain;
  @media screen and (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
    padding: 0 20px;
    padding-bottom: var(--cta-offset);
    -webkit-overflow-scrolling: touch;
  }
`

export const Fade = styled.div<{ position: 'top' | 'bottom' }>`
  position: sticky;
  left: 0;
  right: 0;
  height: 45px;
  pointer-events: none;
  z-index: 2;
  background: linear-gradient(
    to ${(p) => (p.position === 'top' ? 'bottom' : 'top')},
    ${groveTheme.colors.primaryWhite} 0%,
    rgba(255, 255, 255, 0) 100%
  );
  ${(p) =>
    p.position === 'top'
      ? `
        top: -1px;
        margin-top: -40px;
      `
      : `
        bottom: 0;
        @media screen and (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
          display: none;
        }
      `}
`

export const SurveyTitle = styled.h2`
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: 0;
  text-align: left;
  color: ${groveTheme.colors.naturalCharcoal};
  margin: 20px 0 10px;
  max-width: 240px;

  @media screen and (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
    margin-top: 10px;
  }
`

export const SurveySubtitle = styled.p`
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0;
  font-weight: 400;
  text-align: left;
  color: ${groveTheme.colors.primaryStone};
  max-width: 260px;
  margin: 0 0 30px;
`

export const SurveyList = styled.div`
  max-width: 340px;
  margin: 0 auto;
  width: 340px;
  padding-bottom: 80px;
  @media screen and (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
    padding-bottom: var(--cta-offset);
  }
`

export const SurveyInputContainer = styled.div<{
  isSelected?: boolean
  isMultiline?: boolean
}>`
  width: 340px;
  height: ${(p) => (p.isMultiline ? 'auto' : '62px')};
  min-height: 62px;
  font-weight: 600;
  font-size: 14px;
  padding: 20px;
  background: ${(p) =>
    p.isSelected
      ? transparentize(0.92, groveTheme.colors.primaryGreen)
      : groveTheme.colors.primaryIvory};
  border-radius: 10px;
  box-shadow: ${(p) =>
    p.isSelected
      ? `inset 0 0 0 2px ${groveTheme.colors.primaryGreen}`
      : 'none'};
  display: flex;
  align-items: ${(p) => (p.isMultiline ? 'flex-start' : 'center')};
  justify-content: space-between;
  line-height: 22px;
  margin: 0 auto;
  cursor: pointer;

  &:not(:last-of-type) {
    margin-bottom: 15px;
  }
`

export const SurveyOptionLabel = styled.div`
  max-width: 258px;
  word-break: break-word;
`

export const SurveyCheckbox = styled(CheckboxInput)`
  margin-left: auto;
  padding-bottom: 0;
  position: relative;
  align-self: center;

  > label {
    margin: 0;
    padding: 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
  }

  > input + label::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 22px;
    height: 22px;
    border-radius: 8px;
    background: ${groveTheme.colors.primaryIvory};
    border: 1px solid ${groveTheme.colors.primaryStoneLight};
  }

  > input:not(:checked):focus + label::before {
    background: ${groveTheme.colors.primaryIvory};
    border-color: ${groveTheme.colors.primaryStoneLight};
    box-shadow: none;
  }

  > input:checked + label::before {
    background: ${theme.colors.green};
    border-color: ${theme.colors.green};
  }

  > input:checked + label::after {
    opacity: 1;
  }
`

export const SurveyButtonContainer = styled.div<{
  hasAnimation?: boolean
}>`
  border-top: 1px solid ${groveTheme.colors.primaryIvory};
  padding: 0 30px 30px;
  width: 100%;
  text-align: center;
  position: relative;

  @media screen and (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 20px calc(20px + env(safe-area-inset-bottom, 0));
    border-top: none;
    background: ${groveTheme.colors.primaryWhite};
    z-index: 100;
  }

  ${(props) =>
    props.hasAnimation &&
    `
    position: relative;
    z-index: 3;
  `}
`

export const StyledDisclaimer = styled(Disclaimer)`
  width: 262px;
  margin: 30px auto;
  color: ${groveTheme.colors.primaryStone};

  @media screen and (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
    margin-top: 0;
    margin-bottom: 20px;
  }

  p {
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 0;
    line-height: 16px;
    text-align: center;
  }

  a {
    text-decoration: underline;
    color: ${groveTheme.colors.primaryStone};
  }
`

export const SurveyStyledButton = styled(GroveButton)`
  width: 262px;
  margin: 0 auto 10px;

  @media screen and (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
    width: 100%;
  }
`

export const NEXT_STEPS_SLIDE_DURATION_MS = 4750

export const nextStepsSlideTimeline = keyframes`
  0% {
    transform: translateY(80px);
    opacity: 0;
  }
  15.8% {
    transform: translateY(0);
    opacity: 1;
  }
  84.2% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(80px);
    opacity: 0;
  }
`

export const NextStepsSlideContent = styled.div`
  animation: ${nextStepsSlideTimeline} ${NEXT_STEPS_SLIDE_DURATION_MS}ms
    cubic-bezier(0.64, 0.04, 0.35, 1) forwards;
  text-align: left;
  max-width: 335px;
  margin: auto;
  padding: 40px;
  font-size: ${groveTheme.fontSize._30};
  font-weight: ${groveTheme.fontWeight.demiBold};
  line-height: ${groveTheme.lineHeight._41};
  color: ${groveTheme.colors.naturalCharcoal};
  box-sizing: border-box;

  @media screen and (max-width: ${groveTheme.dimensions.breakpointsSmall}px) {
    padding: 30px;
  }
`
